import { ReactNode } from "react";
import { cx } from "@app/shared/utils/cx";
import styles from "./TrackOrderInput.module.css";

export type TrackOrderInputProps = {
  icon?: ReactNode;
  placeholder?: string;
  helperText?: string;
  isError?: boolean;
  onChange?: React.ChangeEventHandler<HTMLInputElement>;
  onKeyDown?: React.KeyboardEventHandler<HTMLInputElement>;
};

export const TrackOrderInput = ({ icon, placeholder, helperText, isError, onChange, onKeyDown }: TrackOrderInputProps) => (
  <>
    <div className={cx(styles.field, isError && styles.error)}>
      {icon}
      <input
        className={styles.input}
        autoComplete="on"
        placeholder={placeholder}
        onChange={onChange}
        onKeyDown={onKeyDown}
      />
    </div>
    <span className={cx(styles.helperText, isError && styles.error)}>{helperText}</span>
  </>
);
